import checkoutSuccessImage from '@/public/assets/images/IconSuccess.png'
import Image from 'next/image'
import { type ReactNode } from 'react'
import { CheckoutFail } from '../Icon/CheckoutFail'

export interface PageNotification {
  className?: string
  children: ReactNode
  isCanceled?: boolean
  type: 'page' | 'detail'
  onClick?: () => void
}

export function PageNotification({
  className = '',
  children,
  isCanceled,
  type,
}: PageNotification) {
  return (
    <div
      className={`${className} checkoutPaymentDetail mb-4 px-5 py-2 text-center`}
    >
      <div className='checkoutPaymentHighLight flex items-center justify-center gap-3'>
        {type === 'page' &&
          (isCanceled ? (
            <div className='h-16 w-16'>
              <CheckoutFail className='' />
            </div>
          ) : (
            <Image
              src={checkoutSuccessImage}
              alt='Checkout Success'
              className='h-16 w-16 min-w-[64px]'
            />
          ))}
        <div className='text-left text-base'>{children}</div>
      </div>
    </div>
  )
}

export default PageNotification
